import TennantList from "./components/List"
import TennantForm from "./components/Form"
import TennantView from "./components/View"

let module = "tennants"

export default [
  {
    path: "tennants",
    component: TennantList,
    meta: { module: module, permissions: ["tennant-access"] }
  },
  {
    path: "tennants/create",
    component: TennantForm,
    props: true,
    meta: { module: module, permissions: ["tennant-create"] }
  },
  {
    path: "tennants/edit/:id",
    component: TennantForm,
    props: true,
    meta: { module: module, permissions: ["tennant-edit"] }
  },
  {
    path: "tennants/view/:id",
    component: TennantView,
    props: true,
    meta: { module: module, permissions: ["tennant-access"] }
  }
]
